module.exports = __webpack_public_path__ + "Frame418-9317b347.webp";